import { BillingItemType } from './billingItemType';
import { Contract } from './contract';
import { Model } from './model';

export class BillingItems extends Model {


  id?: number;
  billingSetupId?: number;
  billingItemsType?: BillingItemType[];
  description?: string;
  unitCost?: number;
  percentage?: number;
  invoicePeriod?: number;
  units?: number;
  contract?: Contract;
  identifier?: string;

}

